<template>
    <div class="masterslave h-box is-growy is-growx">
        <div class="masterslave__sidebar is-growy">
            <z-content>
                <h3 class="border-bottom">Available releases</h3>
                <div
                    class="list"
                >
                    <div
                        v-for="release in releases"
                        :key="release.id"
                        :class="{'active': selectedRelease && selectedRelease.ReleaseDate == release.ReleaseDate}"
                        class="list__item h-box"
                        @click="select(release)"
                    >
                        {{ release.ReleaseDate }}
                        <z-tested v-if="release.Tested"/>
                    </div>
                </div>
            </z-content>
        </div>
        <div class="masterslave__main is-growy is-growx">
            <z-release/>

            <z-content
                v-if="!selectedRelease">
                <h3 class="border-bottom">Please select a release from the left panel</h3>
                <div class="h-box">
                    <img
                        src="/images/main.svg"
                        alt="Deployment"
                    >
                </div>
            </z-content>
        </div>
        <slot/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            x: 0,
        };
    },
    computed: {
        ...mapGetters([
            'releases',
            'environments',
            'selectedRelease'
        ])
    },

    watch: {
        releases(newValue) {
            if(this.selectedRelease) {
                const newReleaseData = this.releases.find((release) => {
                    return release.ReleaseDate == this.selectedRelease.ReleaseDate;
                });
                this.$store.dispatch('selectRelease', newReleaseData);
            }
        }
    },

    methods: {

        allowed(release, actionName) {
            return release.AllowedActions.includes(actionName);
        },

        select(release) {
            this.$store.dispatch('selectRelease', release);
            this.$store.dispatch('fetchEnvironments');
        },
    }
};
</script>

<style lang="scss">

@import '../assets/framework';

@keyframes rotator {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

$content-color: $base-color;
$content-background: $base-background;
$content-max-width: 980px;

.masterslave {
    width: 100vw;
    height: 100vh;
    padding: $base-padding;

    &__sidebar {
        margin-right: $base-padding;
        width: 33%;
        flex-basis: 33%;

        .list {
            &__item {
                height: 48px;
                padding: 0 16px;
                &:hover {
                    color: rgb(32, 31, 30);
                    background: rgb(243, 242, 241);
                }
                &:focus, &:active, &.active {
                    background: rgb(237, 235, 233);
                }
            }
        }
    }
    h3 {
        font-size: 28px;
        font-weight: 600;
        line-height: 24px;
    }

    .border-bottom {
        padding-bottom: 30px;
        border-bottom: 1px solid rgb(161, 159, 157);
    }
    &__main {

        img {
            display: block;
            width: 500px;
            height: 500px;
            margin: 50px;
        }

        .environment--inprogress {
            opacity: 0.6;
        }

        .inprogress {
            display: inline-block;
            vertical-align: bottom;
            i {
                animation-name: rotator;
                animation-duration: 1.3s;
                animation-iteration-count: infinite;
                animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
            }
        }
    }
}
</style>
